/* SpeakyPaws — interacciones de las secciones mt-* (sin librerías externas).
   Se carga como módulo desde cada sección; cada init comprueba si su
   elemento existe, así el mismo archivo sirve para todas las páginas. */

const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- Animaciones de entrada (un único observador compartido) ---------- */
function initReveal() {
  const els = document.querySelectorAll('.mt-reveal:not(.mt-visible), .mt-stagger:not(.mt-visible)');
  if (!els.length) return;
  if (sinMovimiento || !('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entradas) => {
      entradas.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach((el) => io.observe(el));
}

/* ---------- Parallax suave en imágenes marcadas con data-mt-parallax ---------- */
function initParallax() {
  if (sinMovimiento) return;
  const imgs = [...document.querySelectorAll('[data-mt-parallax]')];
  if (!imgs.length) return;
  let pendiente = false;
  const pintar = () => {
    const vh = window.innerHeight;
    imgs.forEach((img) => {
      const caja = img.parentElement.getBoundingClientRect();
      if (caja.bottom < 0 || caja.top > vh) return;
      const intensidad = parseFloat(img.dataset.mtParallax) || 0;
      const progreso = (caja.top + caja.height / 2 - vh / 2) / vh;
      img.style.transform = `translate3d(0, ${(-progreso * intensidad).toFixed(1)}px, 0)`;
    });
    pendiente = false;
  };
  window.addEventListener('scroll', () => {
    if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
  }, { passive: true });
  pintar();
}

/* ---------- Galería del producto ---------- */
function initGalerias() {
  document.querySelectorAll('[data-mt-galeria]').forEach((gal) => {
    if (gal.dataset.listo) return;
    gal.dataset.listo = '1';
    const principal = gal.querySelector('[data-mt-principal]');
    const minis = [...gal.querySelectorAll('[data-mt-mini]')];
    if (!principal || !minis.length) return;
    let actual = 0;
    const mostrar = (i) => {
      actual = (i + minis.length) % minis.length;
      const mini = minis[actual];
      principal.classList.add('mt-cambiando');
      const nueva = new Image();
      nueva.src = mini.dataset.src;
      const aplicar = () => {
        principal.src = mini.dataset.src;
        principal.srcset = mini.dataset.srcset || '';
        principal.alt = mini.dataset.alt || '';
        requestAnimationFrame(() => principal.classList.remove('mt-cambiando'));
      };
      nueva.complete ? aplicar() : (nueva.onload = aplicar, nueva.onerror = aplicar);
      minis.forEach((m, j) => m.setAttribute('aria-current', j === actual ? 'true' : 'false'));
      mini.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: sinMovimiento ? 'auto' : 'smooth' });
    };
    minis.forEach((m, i) => m.addEventListener('click', () => mostrar(i)));
    gal.querySelector('[data-mt-prev]')?.addEventListener('click', () => mostrar(actual - 1));
    gal.querySelector('[data-mt-next]')?.addEventListener('click', () => mostrar(actual + 1));
    // Deslizar con el dedo en móvil
    let x0 = null;
    principal.parentElement.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    principal.parentElement.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) mostrar(actual + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    gal.mtMostrarMedia = (mediaId) => {
      const i = minis.findIndex((m) => m.dataset.mediaId === String(mediaId));
      if (i >= 0) mostrar(i);
    };
  });
}

/* ---------- Formulario de compra: variantes, cantidad, carrito ---------- */
function formatoPrecio(centimos, formato) {
  const valor = (centimos / 100).toFixed(2);
  if (!formato) return valor;
  return formato.replace(/\{\{\s*(\w+)\s*\}\}/, (_, tipo) => {
    if (tipo.includes('no_decimals')) return Math.round(centimos / 100).toString();
    if (tipo.includes('comma')) return valor.replace('.', ',');
    return valor;
  });
}

function initCompras() {
  document.querySelectorAll('[data-mt-compra]').forEach((caja) => {
    if (caja.dataset.listo) return;
    caja.dataset.listo = '1';
    const datos = caja.querySelector('[data-mt-variantes]');
    const variantes = datos ? JSON.parse(datos.textContent) : [];
    const formatoDinero = caja.dataset.formato || '';
    const form = caja.querySelector('form[action*="/cart/add"]');
    const inputId = form?.querySelector('input[name="id"]');
    const boton = caja.querySelector('[data-mt-boton]');
    const textoBoton = boton?.querySelector('[data-mt-boton-texto]');
    const precio = caja.querySelector('[data-mt-precio]');
    const antes = caja.querySelector('[data-mt-antes]');
    const ahorro = caja.querySelector('[data-mt-ahorro]');
    const elegido = caja.querySelectorAll('[data-mt-elegido]');
    const galeria = document.querySelector('[data-mt-galeria]');
    const barra = document.querySelector('[data-mt-barra]');

    const actualizar = () => {
      if (!variantes.length) return;
      const sel = [...caja.querySelectorAll('[data-mt-opcion]')].map((fs) => fs.querySelector('input:checked')?.value);
      const v = variantes.find((vr) => vr.options.every((o, i) => o === sel[i]));
      elegido.forEach((el, i) => { if (sel[i]) el.textContent = sel[i]; });
      if (!v) {
        boton.disabled = true;
        textoBoton.textContent = caja.dataset.txtNoDisponible;
        return;
      }
      inputId.value = v.id;
      if (precio) precio.textContent = formatoPrecio(v.price, formatoDinero);
      const rebaja = v.compare_at_price && v.compare_at_price > v.price;
      if (antes) { antes.hidden = !rebaja; if (rebaja) antes.textContent = formatoPrecio(v.compare_at_price, formatoDinero); }
      if (ahorro) {
        ahorro.hidden = !rebaja;
        if (rebaja) ahorro.textContent = ahorro.dataset.plantilla.replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
      }
      boton.disabled = !v.available;
      textoBoton.textContent = v.available ? caja.dataset.txtComprar : caja.dataset.txtAgotado;
      if (barra) {
        const bp = barra.querySelector('[data-mt-barra-precio]');
        if (bp) bp.textContent = formatoPrecio(v.price, formatoDinero);
      }
      if (v.featured_media && galeria?.mtMostrarMedia) galeria.mtMostrarMedia(v.featured_media.id);
      const url = new URL(window.location.href);
      if (caja.dataset.actualizarUrl === 'true') {
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    };
    caja.querySelectorAll('[data-mt-opcion] input').forEach((inp) => inp.addEventListener('change', actualizar));

    // Cantidad
    const cant = caja.querySelector('[data-mt-cantidad]');
    if (cant) {
      const inp = cant.querySelector('input');
      cant.querySelector('[data-mt-menos]').addEventListener('click', () => { inp.value = Math.max(1, (+inp.value || 1) - 1); });
      cant.querySelector('[data-mt-mas]').addEventListener('click', () => { inp.value = (+inp.value || 1) + 1; });
    }

    // Añadir al carrito sin salir de la página (abre el carrito lateral del tema).
    // Si algo falla, el formulario se envía de forma normal y lleva al carrito.
    if (form && document.querySelector('cart-drawer-component')) {
      form.addEventListener('submit', async (ev) => {
        ev.preventDefault();
        if (boton.disabled) return;
        const original = textoBoton.textContent;
        boton.disabled = true;
        boton.setAttribute('aria-busy', 'true');
        const errorEl = caja.querySelector('[data-mt-error]');
        if (errorEl) errorEl.hidden = true;
        let enviado = false;
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const fd = new FormData(form);
          const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
          if (ids.length) fd.append('sections', ids.join(','));
          const diferido = CartLinesUpdateEvent.createPromise();
          form.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }],
            promise: diferido.promise,
          }));
          const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(raiz + 'cart/add.js', {
            method: 'POST', body: fd,
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          }).then((r) => r.json());
          enviado = true; // a partir de aquí el producto ya está en el carrito: nunca reenviar el formulario
          const carrito = await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const error = Boolean(res.status);
          diferido.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
            detail: { items: carrito.items, source: 'mt-producto', sourceId: form.id, sections: res.sections, didError: error },
          });
          if (error) {
            if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
          } else {
            textoBoton.textContent = caja.dataset.txtAnadido;
            const cajon = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
            setTimeout(() => { if (cajon && !cajon.isOpen && typeof cajon.open === 'function') cajon.open(); }, 350);
            setTimeout(() => { textoBoton.textContent = original; }, 2200);
          }
        } catch (e) {
          // Si falló antes de añadir: envío normal del formulario. Si ya se añadió: ir al carrito.
          if (enviado) window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          else form.submit();
          return;
        } finally {
          boton.disabled = false;
          boton.removeAttribute('aria-busy');
        }
      });
    }
  });
}

/* ---------- Barra de compra fija en móvil ---------- */
function initBarra() {
  const barra = document.querySelector('[data-mt-barra]');
  const ancla = document.querySelector('[data-mt-boton]');
  if (!barra || !ancla || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([e]) => {
    barra.classList.toggle('mt-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(ancla);
  barra.querySelector('[data-mt-barra-ir]')?.addEventListener('click', () => {
    ancla.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
  });
}

/* ---------- FAQ: solo una abierta a la vez (si la sección lo pide) ---------- */
function initFaq() {
  document.querySelectorAll('[data-mt-faq-unica]').forEach((lista) => {
    lista.addEventListener('toggle', (e) => {
      if (!e.target.open) return;
      lista.querySelectorAll('details[open]').forEach((d) => { if (d !== e.target) d.open = false; });
    }, true);
  });
}

/* ---------- Fecha estimada de entrega (días laborables) ---------- */
function initEntrega() {
  document.querySelectorAll('[data-mt-entrega]').forEach((el) => {
    const sumar = (n) => {
      const d = new Date();
      let quedan = n;
      while (quedan > 0) {
        d.setDate(d.getDate() + 1);
        const dia = d.getDay();
        if (dia !== 0 && dia !== 6) quedan--;
      }
      return d;
    };
    const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' });
    const rango = `${fmt.format(sumar(+el.dataset.min || 8))} – ${fmt.format(sumar(+el.dataset.max || 14))}`;
    const partes = (el.dataset.plantilla || '[fechas]').split('[fechas]');
    el.textContent = '';
    el.append(partes[0]);
    const b = document.createElement('strong');
    b.textContent = rango;
    el.append(b, partes.slice(1).join(''));
  });
}

function initTodo() {
  initReveal();
  initParallax();
  initGalerias();
  initCompras();
  initBarra();
  initFaq();
  initEntrega();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
else initTodo();

// Editor de Shopify: re-inicializa al añadir o editar secciones
document.addEventListener('shopify:section:load', initTodo);
